<template>
  <div class="question-media">
    <vrecorder
      v-if="is_video"
      class="question_video"
      :src="media.url"
      :show_recorder="false"
      :not_editable="is_separate_page"
      :hide_safari="false"
      :disabled="is_blocked_video || isDisabled"
      :is-mirror="false"
      show_player
      is_youtube
      is_full_width
      test_question
      @player_play="play"
      @player_end="end"
      @player_waiting="player_waiting"
    />

    <vaudio
      class="audio"
      v-if="is_audio"
      :src="media.url"
      :name="media.title"
      :disabled="is_blocked_audio || isDisabled"
      :show_title="false"
      @play="play"
      @end="end"
      @change_duration="change_duration"
      @waiting="player_waiting"
      @playing="playing"
    />
  </div>
</template>

<script>
export default {
  name: 'question_media',

  props: {
    media: {
      type: Object,
      default: () => {}
    },

    is_disabled: {
      type: Boolean,
      default: false
    },

    is_separate_page: {
      type: Boolean,
      default: false
    },

    isDisabled: {
      type: Boolean,
      default: false
    },

    time_inited: {
      type: [Number],
      default: null
    }
  },

  data() {
    return {
      disabled: false,
      is_started: false,
      duration: 0,
      time_left: null,
      timer_id: null
    };
  },

  computed: {
    is_video() {
      if (!this.media) {
        return false;
      }
      return this.media.type === 'youtube';
    },

    is_audio() {
      if (!this.media) {
        return false;
      }
      return this.media.type === 'audio';
    },

    is_blocked_video() {
      return this.media.is_blocked && this.time_inited > 0;
    },

    is_blocked_audio() {
      return (
        (this.is_separate_page && this.is_started) ||
        (this.is_disabled && this.is_started && !this.is_separate_page) ||
        (this.media.is_blocked && this.time_inited > 0)
      );
    }
  },

  mounted() {
    if (this.media && this.media.type === 'youtube') {
      const id = this.youtube_get_id(this.media.url);
      window
        .fetch(
          `https://www.googleapis.com/youtube/v3/videos?id=${id}&part=contentDetails&key=AIzaSyCWzLActlnZdGiaVDZBtamiit1k_uLdNFE`
        )
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (data && data.items && data.items[0] && data.items[0].contentDetails) {
            this.duration = this.convert_time(data.items[0].contentDetails.duration);
          }
        });
    }
  },

  methods: {
    player_waiting() {
      this.$emit('stop_timer');
    },

    playing() {
      this.$emit('start_timer');
    },

    change_duration(val) {
      this.duration = val;
    },

    end() {
      this.disabled = true;
      this.$emit('end');
    },

    play() {
      this.$emit('start_timer');

      if (this.is_started) {
        return;
      }

      if (this.is_separate_page) {
        this.is_started = true;
        this.start_timer();
      }

      this.$emit('start_media');
    },

    start_timer() {
      this.time_left = this.duration;
      this.timer_id = setInterval(() => {
        if (this.time_left === 0 || this.time_left < 0) {
          clearInterval(this.timer_id);
          this.end();
        } else {
          this.time_left--;
        }
      }, 1000);
    },

    youtube_get_id(url) {
      let ID = '';
      url = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
      if (url[2] !== undefined) {
        ID = url[2].split(/[^0-9a-z_\-]/i);
        ID = ID[0];
      } else {
        ID = url;
      }
      return ID;
    },

    convert_time(duration) {
      if (!duration) {
        return 0;
      }
      var a = duration.match(/\d+/g);

      if (duration.indexOf('M') >= 0 && duration.indexOf('H') == -1 && duration.indexOf('S') == -1) {
        a = [0, a[0], 0];
      }

      if (duration.indexOf('H') >= 0 && duration.indexOf('M') == -1) {
        a = [a[0], 0, a[1]];
      }
      if (duration.indexOf('H') >= 0 && duration.indexOf('M') == -1 && duration.indexOf('S') == -1) {
        a = [a[0], 0, 0];
      }

      duration = 0;

      if (a.length == 3) {
        duration = duration + parseInt(a[0]) * 3600;
        duration = duration + parseInt(a[1]) * 60;
        duration = duration + parseInt(a[2]);
      }

      if (a.length == 2) {
        duration = duration + parseInt(a[0]) * 60;
        duration = duration + parseInt(a[1]);
      }

      if (a.length == 1) {
        duration = duration + parseInt(a[0]);
      }
      return duration;
    }
  }
};
</script>

<style lang="scss">
.question_video {
  background-color: transparent;
  border: none;
  width: 100%;
}

.question-media {
  display: flex;
  justify-content: center;
  width: 100%;
}
</style>
